import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const ButtonCloseDefaultProps = {
  ...BaseDefaultProps,
  animHover: true,
  display: 'inline',
  icon: null,
  id: '',
  onClick: () => null,
  reversed: false,
  title: 'Close',
};

export const ButtonClosePropTypes = {
  ...BasePropTypes,
  animHover: PropTypes.bool,
  display: PropTypes.oneOf(['inline', 'block']),
  icon: PropTypes.element,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  reversed: PropTypes.bool,
  title: PropTypes.string,
};
